import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { useAllPayeeEngagementsQuery } from "../../../../query/payeeEngagements/queries/useAllPayeeEngagementsQuery";

interface ContractorsCountCellProps {
  engagementId: string;
}

export function ContractorsCountCell({
  engagementId
}: ContractorsCountCellProps) {
  const queryEngagements = useAllPayeeEngagementsQuery({
    filter: {
      engagementId
    },
    page: {
      size: 1
    }
  });

  return queryEngagements.isInitialLoading ? (
    <WSElement shimmer>Loading</WSElement>
  ) : (
    <WSTableCell text={`${queryEngagements.data?.summary.listSize ?? "-"}`} />
  );
}
